import(/* webpackMode: "eager", webpackExports: ["PageHeader"] */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/components/common/page-header/page-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Prefooter"] */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/components/common/prefooter/prefooter.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/components/home-page/app-collections/app-collections.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryGrid"] */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/components/home-page/category-grid/category-grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedIntegrations"] */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/components/home-page/featured-integrations/featured-integrations.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/app/[locale]/integrations/components/layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/todoist-landing-pages/app/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/todoist-landing-pages/app/components/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/todoist-landing-pages/components/SectionHeader/SectionHeader.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/packages/marketist/dist/components/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/packages/marketist/dist/components/image/image.js");
